export const OVERLAY_WIDTH = 1920;
export const OVERLAY_HEIGHT = 1080;

export const WORLD_TILE_WIDTH = 64;
export const WORLD_TILE_HEIGHT = 64;

export const OBS_SAFE_AREA = {
  left: 24,
  top: 24,
  right: 24,
  bottom: 24,
} as const;
